<template>
    <div class="sales-box" :style="nLookImg ? 'height: 100vh;overflow: hidden;' : ''">
<!--        <div class="qrcode" id="qrcode" ref="qrcodeBox"></div>-->
        <div class="one">
            <label class="title">基础信息</label>
            <div class="myLike" @click="goLike">我的喜报</div>
        </div>
        <div>
            <div class="sales-item">
                <div class="sales-name required">
                    <div>合同编号</div>
                    <span>:</span>
                </div>
                <!-- style="width: 37%" -->
                <input type="text" @blur="verify" v-model="project" placeholder="如：HT20210825XXXX" />
                <!-- <div class="seack" @click="bPotNumber = true">选择</div> -->
            </div>
            <div class="sales-item">
                <div class="sales-name required">
                    <div>城市</div>
                    <span>:</span>
                </div>
                <input type="text" v-model="city" disabled />
            </div>
            <div class="sales-item">
                <div class="sales-name required">
                    <div>门店/渠道</div>
                    <span>:</span>
                </div>
                <input type="text" v-model="store" disabled />
            </div>
            <div class="sales-item">
                <div class="sales-name required" style="width:54%">
                    <div>是否体验间体验成交</div>
                    <span>:</span>
                </div>
                <div class="is_design" style="width:46%">
                    <div class="choose" @click="getExperience">
                        <div :class="[bExperience ? 'choose_dian' : 'choose_no_dian']"></div>
                        是
                    </div>
                    <div class="choose" @click="getExperience">
                        <div :class="[!bExperience ? 'choose_dian' : 'choose_no_dian']"></div>
                        否
                    </div>
                </div>
            </div>
            <div class="sales-item" v-if="bExperience">
                <div :class="['sales-name',bExperience&&arrLearn.length?'required':'']">
                    <div>选择体验间</div>
                    <span>:</span>
                </div>
                <input type="text" v-model="lren" readonly placeholder="请选择体验间" @click="getlren" />
            </div>
            <div class="sales-item">
                <div class="sales-name required">
                    <div>是否设计师推荐</div>
                    <span>:</span>
                </div>
                <div class="is_design">
                    <div class="choose" @click="getBhow">
                        <div :class="[bShow ? 'choose_dian' : 'choose_no_dian']"></div>
                        是
                    </div>
                    <div class="choose" @click="getBhow">
                        <div :class="[!bShow ? 'choose_dian' : 'choose_no_dian']"></div>
                        否
                    </div>
                </div>
            </div>
            <div class="sales-item" v-if="bShow">
                <div class="sales-name required">
                    <div>请选择家装公司</div>
                    <span>:</span>
                </div>
                <div class="is_design" @click="getPickShow">
                    {{sDecoration}}
                </div>
            </div>
            <div class="sales-item" v-if="bShow&&nDecorationId === 0">
                <div class="sales-name">
                    <div>家装公司名称</div>
                    <span>:</span>
                </div>
                <input type="text" v-model="sDecorationName" placeholder="请输入家装公司(选填)" />
            </div>
            <div class="sales-item">
                <div class="sales-name required">
                    <div>成交金额</div>
                    <span>:</span>
                </div>
                <input type="number" v-model="money" pattern="[0-9]*" disabled />
            </div>
            <div class="sales-item">
                <div class="sales-name">
                    <div>签单手</div>
                    <span>:</span>
                </div>
                <input type="text" v-model="name1" disabled/>
            </div>
            <div class="sales-item">
                <div class="sales-name">
                    <div>方案设计师</div>
                    <span>:</span>
                </div>
                <input type="text" v-model="name2" placeholder="请输入方案设计师" />
            </div>
            <div class="sales-item">
                <div class="sales-name">
                    <div>技术支持</div>
                    <span>:</span>
                </div>
                <input type="text" v-model="name3" placeholder="请输入技术支持" />
            </div>
        </div>
        <label class="title" v-if="arrTemporary.length">产品型号</label>
        <div class="xinhao" v-if="arrTemporary.length">
            <div class="sales-item" v-for="(item, index) in arrTemporary" :key="index">
                <div class="name required name-required" :class="{'none-required':item.type=='TEMP'}" :style="{'width':item.isEditType?'60%':'45%'}" @click="openSelectTemp(item,index)">
                    <div>{{item.type=='TEMP'?'请选择产品品类':item.type }}</div>
                    <span>:</span>
                </div>
                <div class="shopp_warp shopp_warp-two">
                    <div class="shopp_list">
                        <div class="shopp_name">
                            {{item.model_show?item.item_name:'' }}
                        </div>
                        <div></div>
                        <div class="addOrDel">
                            <div class="numa num">
                                <input @click.stop type="number" class="numInput" disabled max="99" min="0" pattern="[0-9]*" :value="item.num" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="xinhao" v-if="false">
            <div class="sales-item" v-for="(item, index) in arrShoppOpen" :key="index">
                <div class="twoListType" v-if="item.listType == 2">
                    <div class="twoListType_item" v-for="(ritem, rindex) in item.arrChecked" :key="rindex" @click="getListType(index, rindex)">
                        <div :class="[
                                ritem.openType
                                    ? 'openListType'
                                    : 'openNoListType',
                            ]"></div>
                        <div>{{ ritem.openName }}</div>
                    </div>
                </div>
                <div class="left_border" v-if="
                        item.listType != 2 &&
                        !item.choose &&
                        item.system_id == 0
                    ">
                    <div class="twoListType_item" @click="getListType2(item, index)">
                        <div :class="[
                                !item.back ? 'openListType' : 'openNoListType',
                            ]"></div>
                    </div>
                </div>
                <div :class="['sales-name', item.choose ? 'required' : '']" v-if="item.listType != 2">
                    <div>{{ item.name }}</div>
                    <span>:</span>
                </div>
                <div class="shopp_warp" @click.stop="
                        item.listType == 0 ? getOptien(item, index) : ''
                    " v-if="item.listType != 2">
                    <div class="shopp_list" v-for="(sit, sindex) in item.arrChecked" :key="sindex">
                        <div class="shopp_name" v-if="item.listType == 0">
                            {{ sit.goods_name }}
                        </div>
                        <div v-if="item.listType == 1"></div>
                        <div class="addOrDel">
                            <div class="orInatdel" @click.stop="delNum(sit, sindex, index)"></div>
                            <div :class="item.choose ? 'numa' : 'num'">
                                <input @click.stop type="number" class="numInput" max="99" min="0" pattern="[0-9]*" @input="getChange" @blur="getNumInput(sindex, index)" :value="sit.nNum == 0 ? '' : sit.nNum" />
                            </div>
                            <div class="orInat" @click.stop="addNum(sit, sindex, index)"></div>
                        </div>
                    </div>
                    <input v-if="!item.arrChecked.length && item.listType == 0" type="text" readonly :placeholder="'请选择' + item.name" />
                </div>
            </div>
        </div>
<!--        <div class="opens-bottom" v-if="arrShoppOpen.length < 15" @click="opens">-->
<!--            展开输入更多品类-->
<!--        </div>-->
        <!-- <div>---查看更多---</div> -->
        <!-- submit  参数1为直接生成  0为预览 -->
        <div class="submit" @click="submit(1)">生成喜报</div>
        <!-- 选择商品弹窗 -->
        <add-shopp :title="nameTitle" :shoppType.sync="shoppType" :bEditModalShow.sync="bEditModalShow" @selectChange="selectChange"></add-shopp>
        <!-- 预览图片 -->
        <div class="lookImg" v-if="nLookImg" @click.stop="nLookImg = false">
            <div class="lookbtn">
                <div class="lookBaek" @click.stop="bAddImg = true">
                    生成喜报
                </div>
                <div class="lookBaek" @click.stop="nLookImg = false">修改</div>
            </div>
            <div class="img_url">
                <img :src="lookImgUrl" alt="" />
            </div>
        </div>
        <!-- 上传定金凭证 -->
        <div class="addImg" v-if="bAddImg" @click.stop="getAddImg">
            <div class="addImgWarp" @click.stop>
                <div class="addTitle">提交定金凭证</div>
                <div class="addImgUrl">
                    <input type="file" accept="image/*" class="uploadImage" @change="imgChange($event, 1)" style="opacity: 0" v-if="!imgUrl.src" />
                    <div class="tip" v-if="!imgUrl.src">
                        <h3>上传凭证</h3>
                        <p>点击这里上传图纸<br />支持拓展名：.png.jpg···</p>
                    </div>
                    <img v-if="imgUrl.src" @click.stop="bLookAddImg = true" :src="imgUrl.src" alt="" />
                    <div class="del" @click="del()" v-if="imgUrl.src"></div>
                </div>
                <div class="addBtn" @click.stop="submit(1)">提交</div>
            </div>
        </div>
        <!-- 查看凭证图片 -->
        <div class="lookImgBk" v-if="bLookAddImg" @click.stop="bLookAddImg = false">
            <div class="img_url">
                <img :src="imgUrl.src" alt="" />
            </div>
        </div>
        <contract :bPotNumber.sync="bPotNumber" @inputText="inputText"></contract>
        <!-- picker选择器 -->
        <van-popup v-model="bPickShow" position="bottom">
            <van-picker show-toolbar value-key="agent" @confirm="onConfirm" @cancel="onCancel" :columns="columns" :default-index="defaultIndex" />
        </van-popup>
        <!-- 体验间选择 -->
        <van-popup v-model="bPickLearn" position="bottom">
            <van-picker show-toolbar value-key="new_name" @confirm="onConfirmLearn" @cancel="onCancelLearn" :columns="arrLearn" :default-index="learnIndex" />
        </van-popup>
        <!--temp分类选择-->
        <van-popup v-model="bPickTemp" position="bottom">
            <van-picker show-toolbar value-key="new_name" @confirm="onConfirmTemp" @cancel="bPickTemp=false" :columns="arrSelectInfo" :default-index="learnIndex" />
        </van-popup>
    </div>
</template>

<script>
import oForm from "@/js/form.js";
import oDetail from "@/js/detail.js";
import addShopp from "./components/addshopp.vue";
import contract from "./components/contract.vue";
import oStorage from '@/libsV2/storage.js';
import oCommon from "@/libsV2/common.js";
import QRCode from 'qrcodejs2'
import { getWxSingleConfig } from "@/js/wx.js";
 /**
 * @param { Boolean } alpha  文字是否需要透明
 * @param { Object } ctx canvas的Dom元素
 * @param { String } txt 需要画的文字
 * @param { String } color 文字颜色
 * @param { String } size  文字大小
 * @param { Number } x  绘画的x轴
 * @param { Number } y  绘画的y轴
 * @param { Number } align  文字左对齐还是右对齐，基线对齐
 */
function addTxt(alpha = false, ctx, txt, color, size, x, y, align = "") {
    ctx.fillStyle = color;
    // ctx.strokeStyle = color; //设置笔触的颜色
    if (alpha) {
        //是否需要文字透明
        ctx.globalAlpha = 0.5;
    } else {
        ctx.globalAlpha = 1;
    }
    // ctx.font =
    //     "bold " +
    //     size +
    //     ' "PingFang SC", "PingHei", "STHeitiSC-Light", "Myriad Set Pro", "Lucida Grande", "Helvetica Neue", "Helvetica", "microsoft yahei", "SimHei", "tahoma", "Arial", "Verdana", "sans-serif"';
     ctx.font = size + "'myFont2'";
    if (align != "") {
        ctx.textAlign = align; //在绘制文本时使用的当前文本基线
    }
    ctx.fillText(txt, x, y); //设置文本内容
}
export default {
    components: {
        addShopp,
        contract,
    },
    data() {
        return {
            qrCodeBase64:'',//二维码地址
            dateImgUrlAfter:'',//扫码后的图片
            bPickTemp:false,//temp分类选择器
            bPickLearn: false, //体验间选择器
            bExperience: false, //体验间
            lren: "", //体验间名称
            learnIndex: 0,
            defaultIndex: 0,
            bPickShow: false,
            arrLearn: [],
            columns: [],
            agentName: "", //平台商名称
            nDecorationId: "", //家装公司id
            sDecorationName: "", //选择了其他家装公司的名称
            sDecoration: "", // 家装公司
            project: "", //合同编码
            bPotNumber: false,
            bLookAddImg: false,
            bAddImg: false, //显示上传凭证
            imgUrl: {
                src: "",
                msrc: "",
                w: "",
                h: "",
            }, //定金凭证
            imgLocalUrl: "", //相对路径
            bEditModalShow: false,
            nameTitle: "",
            shoppShow: false,
            bShow: false, //是否选中
            city: "",
            store: "",
            money: "",
            type: "",
            name1: "",
            name2: "",
            name3: "",
            shoppType: 0,
            lookImgUrl: "", //预览图片路径
            nLookImg: false, //预览图片
            arrPsterData: [], //需要上传的数据
            dateImgUrl: "", //上传图片的相对路径
            arrShoppOpen: [
                {
                    name: "主机",
                    arrChecked: [],
                    id: 200,
                    system_id: 0,
                    listType: 0,
                    choose: true,
                    back: false,
                },
                {
                    name: "采暖炉",
                    arrChecked: [],
                    id: 0,
                    system_id: 2,
                    listType: 0,
                    choose: false,
                    back: false,
                },
                {
                    name: "风盘",
                    arrChecked: [{ nNum: 8 }],
                    id: 201,
                    system_id: 0,
                    listType: 1,
                    choose: true,
                    back: true,
                },
                {
                    name: "散热片",
                    arrChecked: [
                        // { openType: false, nNum: 1, openName: "散热片" },
                        { openType: false, nNum: 1, openName: "地暖" },
                        // { openType: false, nNum: 1, openName: "混装" },
                    ],
                    id: 215,
                    system_id: 0,
                    listType: 2,
                    choose: false,
                    back: true,
                },
                {
                    name: "新风",
                    arrChecked: [{ nNum: 0 }],
                    id: 206,
                    system_id: 0,
                    listType: 1,
                    choose: false,
                    back: true,
                },
                {
                    name: "烟灶",
                    arrChecked: [{ nNum: 0 }],
                    id: 1,
                    system_id: 0,
                    listType: 1,
                    choose: false,
                    back: true,
                },
                {
                    name: "中央净水",
                    arrChecked: [{ nNum: 0 }],
                    id: 210,
                    system_id: 0,
                    listType: 1,
                    choose: false,
                    back: true,
                },
                {
                    name: "美容软水",
                    arrChecked: [{ nNum: 0 }],
                    id: 210,
                    system_id: 0,
                    listType: 1,
                    choose: false,
                    back: true,
                },
                {
                    name: "前置",
                    arrChecked: [{ nNum: 0 }],
                    id: 210,
                    system_id: 0,
                    listType: 1,
                    choose: false,
                    back: true,
                },
                {
                    name: "反渗透净水器",
                    arrChecked: [{ nNum: 0 }],
                    id: 210,
                    system_id: 0,
                    listType: 1,
                    choose: false,
                    back: true,
                },
            ],
            nShoppIndex: 0, //分类索引
            million: 0, //万元
            soltShoppNum: 0,
            arrTemporary:[],//临时存储的产品类型
            projectInfo: {
                new_city_idname: "",
                new_channeldesc: "",
                new_salesamount: "",
                new_salesperson_idname: "",
            }, // 合同信息作回显用
            project2: "",
            arrSelectInfo:[],//TEMP类型下拉选择选项
            nEditTempIndex:0,//选择类别的temp索引
        };
    },
    created() {
        $init(() => {
            // 分享配置
            let confit = {
                share_friend_title: "AI-LiNK冷暖风水签单喜报",
                share_friend_desc: "中央空调·采暖·新风·全屋用水",
                share_img_url:
                    "https://aotest-lottery.iwxapi.com/core/images2020/watersystem/ant/xb_icon.jpg",
                share_link: `${window.location.protocol}//${window.location.host}/other/poster/sales`,
            };
            // 调用分享的sdk
            getWxSingleConfig(confit);
            this.getSign()
            // 判断是否是从用户卷宗跳转
            if(this.$route.query.new_code){
                this.project=this.$route.query.new_code
            }
        });
    },
    mounted() {
    },
    watch: {
        // 合同编码发生变化时请求接口，拿到合同信息
        project(val) {
            if (val.length === 14) {
                this.project2 = val;
                // this.getVerify();
                this.getVerifyInfo()
            }
        },
    },
    methods: {
        // 生成二维码
        crateQrcode (code) {
            let that = this
            const qrcodeUrl = require('qrcode');
            console.log(`${window.location.origin}/other/poster/share?code=${code}`,'二维码地址')
            // 生成二维码
            qrcodeUrl.toDataURL(`${window.location.origin}/other/poster/share?code=${code}`, function (err, url) {
                if (err) {
                    this.$toast('二维码生成失败')
                    return;
                }
                // 打印出生成的 base64 地址
                console.log(url, 'base64 地址');
                oForm.getUploadimg({file: url}).then((res) => {
                    that.$store.commit('loadSwitch',false)
                    that.qrCodeBase64=res.data.data.result.media_url
                })
            })
            // return
            // var qrcode = new QRCode(this.$refs.qrcodeBox, {
            //     text:`${window.location.origin}/other/poster/share?code=${code}`,
            //     width: 90,
            //     height: 90,
            //     colorDark: '#000000',
            //     colorLight: '#ffffff',
            //     correctLevel: QRCode.CorrectLevel.L
            // });
            // let container = document.getElementById('qrcode').childNodes[1];
            // console.log(container,'container1')
            // container.onload=function (){
            //     let qrCodeBase64 = container.getAttribute("src")
            // console.log(qrCodeBase64,'container2')
            //     oForm.getUploadimg({file: qrCodeBase64}).then((res) => {
            //         that.$store.commit('loadSwitch',false)
            //         that.qrCodeBase64=res.data.data.result.media_url
            //     })
            // }
        },
        // temp分类选择确认
        onConfirmTemp(e){
            this.arrTemporary[this.nEditTempIndex].type=e
            this.bPickTemp=false
            console.log(this.arrTemporary)
        },
        // temp点击打开下拉
        openSelectTemp(item,index){
            if(item.isEditType){
                this.bPickTemp=true
                this.nEditTempIndex=index
            }
        },
        // 获取签单手列表
        getSign(){
            oDetail.sign().then(res=>{
                console.log(res,'优质')
            })
        },
        getPickShow() {
            if (this.city == "") {
                this.$toast("请先录入城市!");
                return false;
            }
            this.bPickShow = true;
        },
        getlren() {
            if (this.city == "") {
                this.$toast("请先录入城市!");
                return false;
            }
            if (this.arrLearn.length == 0) {
                this.$toast("当前城市没有体验间!");
                return false;
            }
            this.bPickLearn = true;
        },
        onCancelLearn() {
            this.bPickLearn = false;
        },
        onCancel(value, index) {
            this.bPickShow = false;
        },
        onConfirmLearn(value, index) {
            this.bPickLearn = false;
            this.learnIndex = index;
            this.lren = value.new_name;
        },
        onConfirm(value, index) {
            this.bPickShow = false;
            this.defaultIndex = index;
            this.sDecoration = value.agent;
            this.nDecorationId = value.id;
            this.agentName = value.name;
        },
        //跳转我的喜报
        goLike() {
            this.$router.push({ path: "/other/poster/lists" });
        },
        verify() {
            if (this.project !== this.project2) {
                // this.getVerify();
                this.getVerifyInfo()
            }
        },
        // 校验合同编号并且输出详情
        getVerifyInfo(){
            this.$store.commit('loadSwitch',true)
            if(this.project != ""){
                // 首两个字母大写
                let headerStr = this.project.substr(0, 2).toUpperCase();
                let footerStr = this.project.substr(2);
                this.project = headerStr + footerStr;
                this.project.substr(0, 3).toUpperCase();
                oDetail.codeVerification({code: this.project }).then(res=>{
                    this.crateQrcode(this.project)
                    console.log(res.result,'合并验证详情')
                    if(res.result?.code){
                        console.log(434)
                        let projectInfo = res.result;
                        this.arrSelectInfo=projectInfo.type
                        console.log(this.arrSelectInfo,'下拉')
                        this.city = projectInfo.new_city_name;
                        this.store = projectInfo.new_store_name;
                        this.money = projectInfo.new_totalamount;
                        this.name1=projectInfo.new_salesperson_name
                        // 将产品类型暂时存储,等提交时与新增的合并
                        let arrTemporary= []
                        projectInfo.product.forEach(it=>{
                            let obj = {}
                            obj.type=it.type
                            obj.isEditType=it.type=='TEMP'?1:0
                            obj.item_id=0
                            obj.items=it.items
                            obj.num=it.num
                            obj.model_show=it.model_show
                            obj.num_show=it.num_show
                            obj.item_name=''
                            it.items.forEach(it=>{
                                if(obj.item_name==''){
                                    if(!it.model)return
                                    obj.item_name=it.model+','
                                }else{
                                    if(!it.model)return
                                    obj.item_name+=it.model+','
                                }
                            })
                            obj.item_name=obj.item_name.slice(0,obj.item_name.length-1)
                            arrTemporary.push(obj)
                        })
                        this.arrTemporary=arrTemporary
                        console.log(arrTemporary,'处理数据')
                        // 家装公司
                        oDetail
                            .getCompany({
                                city:projectInfo.new_city_name,
                            })
                            .then((res) => {
                                if (res.result.length == 1) {
                                    this.sDecoration =
                                        res.result[0].agent;
                                    this.nDecorationId =
                                        res.result[0].id;
                                    this.agentName =
                                        res.result[0].name;
                                }
                                this.columns = res.result;
                            });
                        // 体验间
                        oDetail
                            .getProjectList({
                                city: projectInfo.new_city_name,
                                limit: 99999,
                            })
                            .then((res) => {
                                this.lren = "";
                                this.arrLearn = res.result.list;
                            });
                        this.$forceUpdate();

                    }
                })
            }
        },
        //校验合同编码
        getVerify() {
            if (this.project != "") {
                // 首两个字母大写
                let headerStr = this.project.substr(0, 2).toUpperCase();
                let footerStr = this.project.substr(2);
                this.project = headerStr + footerStr;
                this.project.substr(0, 3).toUpperCase();
                oDetail.getVerify({ code: this.project }).then((res) => {
                    if (!res.result.contractExist) {
                        this.project = "";
                        this.city = "";
                        this.store = "";
                        this.money = "";
                        this.$toast("请先录入审核合同并保持编码正确!");
                    } else {
                        oDetail
                            .getCodeCheck({ code: this.project })
                            .then((res2) => {
                                if (res2.error == 0) {
                                    let projectInfo = res.result;
                                    this.city = projectInfo.new_city_idname;
                                    this.store = projectInfo.new_store_idname;
                                    this.money = projectInfo.new_totalamount;
                                    // 家装公司
                                    oDetail
                                        .getCompany({
                                            city: projectInfo.new_city_idname,
                                        })
                                        .then((res) => {
                                            if (res.result.length == 1) {
                                                this.sDecoration =
                                                    res.result[0].agent;
                                                this.nDecorationId =
                                                    res.result[0].id;
                                                this.agentName =
                                                    res.result[0].name;
                                            }
                                            this.columns = res.result;
                                        });
                                    // 体验间
                                    oDetail
                                        .getProjectList({
                                            city: projectInfo.new_city_idname,
                                            limit: 99999,
                                        })
                                        .then((res) => {
                                            this.lren = "";
                                            this.arrLearn = res.result.list;
                                        });
                                    this.$forceUpdate();
                                }
                            });
                    }
                });
            }
        },
        // 获取选择的合同编码
        inputText(e) {
            this.project = e;
        },
        getAddImg() {
            this.bAddImg = false;
            this.imgLocalUrl = "";
            this.imgUrl.src = "";
        },
        del() {
            this.imgLocalUrl = "";
            this.imgUrl.src = "";
        },
        async imgChange(e, num) {
            //  console.log(e);
            const sBase64 = await oCommon.upImgCompression(e);
            let data = {
                file: sBase64[0],
            };
            oForm.getUploadimg(data).then((upres) => {
                let imgUrl = upres.data.data.result.media_url;
                let localUrl = upres.data.data.result.local_url;
                let imgUrlData = {
                    src: imgUrl,
                    msrc: imgUrl,
                    w: 400,
                    h: 600,
                };
                this.imgUrl = imgUrlData;
                this.imgLocalUrl = localUrl;
            });
        },
        opens() {
            let arr = this.arrShoppOpen.length;
            if (arr == 15) {
                return;
            } else {
                this.arrShoppOpen.push(
                    {
                        name: "电热水器",
                        arrChecked: [{ nNum: 0 }],
                        id: 210,
                        system_id: 0,
                        listType: 1,
                        choose: false,
                        back: true,
                    },
                    {
                        name: "燃气热水器",
                        arrChecked: [{ nNum: 0 }],
                        id: 210,
                        system_id: 0,
                        listType: 1,
                        choose: false,
                        back: true,
                    },
                    {
                        name: "空气能热水器",
                        arrChecked: [{ nNum: 0 }],
                        id: 210,
                        system_id: 0,
                        listType: 1,
                        choose: false,
                        back: true,
                    },
                    {
                        name: "厨宝",
                        arrChecked: [{ nNum: 0 }],
                        id: 210,
                        system_id: 0,
                        listType: 1,
                        choose: false,
                        back: true,
                    },
                    {
                        name: "淋浴器",
                        arrChecked: [{ nNum: 0 }],
                        id: 210,
                        system_id: 0,
                        listType: 1,
                        choose: false,
                        back: true,
                    },
                    {
                        name: "水暖床垫",
                        arrChecked: [{ nNum: 0 }],
                        id: 210,
                        system_id: 0,
                        listType: 1,
                        choose: false,
                        back: true,
                    }
                );
            }
        },
        getChange(e) {
            this.soltShoppNum = e.target.value;
        },
        getNumInput(sindex, index) {
            this.arrShoppOpen[index].arrChecked[sindex].nNum =
                this.soltShoppNum;
        },
        getListType(sindex, rindex) {
            this.arrShoppOpen[sindex].arrChecked.forEach((it, index) => {
                if (index == rindex) {
                    it.openType = !it.openType;
                }
            });
        },
        getListType2(sindex, rindex) {
            this.arrShoppOpen.forEach((it, index) => {
                if (index == rindex) {
                    it.back = !it.back;
                    this.arrShoppOpen[index].arrChecked.forEach((val) => {
                        if (it.back) {
                            val.nNum = "";
                        } else {
                            val.nNum = 1;
                        }
                    });
                }
            });
        },

        //选择产品回调
        selectChange(item) {
            this.arrShoppOpen[this.nShoppIndex].arrChecked = item;
            console.log(this.arrShoppOpen,'主机数据')
        },
        //选择商品弹窗
        getOptien(item, index) {
            this.nShoppIndex = index;
            // localStorage.setItem("objShoppItem", JSON.stringify(item));
            oStorage.setStorage("objShoppItem", JSON.stringify(item));
            this.bEditModalShow = true;
        },
        getNumber() {
            var patten = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
            this.money = Number(this.money).toFixed(2);
            if (!patten.test(this.money)) {
                this.$toast("请输入正确的数字");
                this.money = "";
                return false;
            }
            //转化万元
            let million = Number(this.money / 10000).toFixed(1);
            let arrMillion = million.split(".");
            if (arrMillion[1] == 0) {
                arrMillion.splice(1, 1);
            }
            this.million = arrMillion.join(".");
            // 判断超出百万不要小数点
            if(Number(this.million)>100){
                this.million=Number(this.million).toFixed(0)
            }
            //  console.log(this.million);
        },
        //加数量
        addNum(item, sindex, index) {
            return
            if (item.nNum == "") {
                item.nNum == 0;
            }
            item.nNum++;
            if (item.nNum > 0) {
                this.arrShoppOpen[index].back = false;
            }
            this.$forceUpdate();
            //  console.log(item.nNum);
        },
        //减数量
        delNum(item, sindex, index) {
            return
            item.nNum--;
            if (item.nNum < 0) {
                item.nNum = 0;
            }
            if (item.nNum == 0 && this.arrShoppOpen[index].listType == 0) {
                this.arrShoppOpen[index].arrChecked.splice(sindex, 1);
            }
            if (item.nNum == 0 && this.arrShoppOpen[index].listType == 1) {
                this.arrShoppOpen[index].back = true;
            }
        },
        //循环截取字符串
        getStrObj() {
            return new Promise((resolve) => {
                if (this.project == "") {
                    this.$toast("请填写合同编号!");
                    return false;
                }
                if (this.store == "") {
                    this.$toast("请填写门店/渠道!");
                    return false;
                }
                if (this.city == "") {
                    this.$toast("请填写城市!");
                    return false;
                }
                if (this.bExperience && this.arrLearn.length && this.lren == '') {
                    this.$toast("请选择体验间!");
                    return false;
                }
                if (this.sDecoration == "" && this.bShow) {
                    this.$toast("请选择家装公司!");
                    return false;
                }
                if (this.money == "") {
                    this.$toast("请填写成交金额!");
                    return false;
                }
                let arrCheckShopp = this.arrShoppOpen.filter((it) => {
                    return it.arrChecked.length > 0 && it.listType == 0;
                });
                let arrOneShopp = this.arrShoppOpen.filter((it) => {
                    return it.listType == 1;
                });
                if (arrCheckShopp.length) {
                    //判断是否选择主机
                    let arrZjShopp = arrCheckShopp.filter((it) => {
                        return it.id == 200;
                    });
                    //判断是否选择壁挂炉
                    let arrBgrShopp = arrCheckShopp.filter((it) => {
                        return it.id == 0;
                    });
                    // if (!arrBgrShopp.length) {
                    //     this.$toast("请选择壁挂炉!");
                    //     return false;
                    // }
                    if (!arrZjShopp.length) {
                        this.$toast("请选择主机!");
                        return false;
                    }
                }
                if (arrOneShopp.length) {
                    //判断是否选择风盘
                    let arrFpShopp = arrOneShopp.filter((it) => {
                        return it.id == 201 && it.arrChecked[0].nNum == 0;
                    });
                    if (arrFpShopp.length) {
                        this.$toast("请选择风盘数量!");
                        return false;
                    }
                }
                let zStrSlot = "";
                // 文字拼接   商品名称 + 多少台
                this.arrShoppOpen.forEach((it) => {
                    it.slotTemp = "";
                    it.arrProduct = [];
                    if (it.listType == 0) {
                        it.arrChecked.forEach((item) => {
                            let temp = it.name + item.goods_name;
                            if (item.nNum > 0) {
                                it.arrProduct.push({
                                    type: it.name,
                                    item_id: item.id,
                                    item_name: item.goods_name,
                                    num: item.nNum,
                                });
                            }
                            if (item.nNum > 1) {
                                if (it.slotTemp == "") {
                                    it.slotTemp =
                                        it.slotTemp + temp + item.nNum + "台";
                                } else {
                                    it.slotTemp =
                                        it.slotTemp +
                                        "+" +
                                        temp +
                                        item.nNum +
                                        "台";
                                }
                            } else {
                                if (it.slotTemp == "") {
                                    it.slotTemp = it.slotTemp + temp;
                                } else {
                                    it.slotTemp = it.slotTemp + "+" + temp;
                                }
                            }
                        });
                    }
                    if (it.listType == 1) {
                        it.arrChecked.forEach((item) => {
                            if (item.nNum > 0) {
                                it.arrProduct.push({
                                    type: it.name,
                                    item_id: item.id || "",
                                    item_name: item.goods_name || "",
                                    num: item.nNum,
                                });
                            }
                            if (item.nNum > 1) {
                                // if (it.id == 201) {
                                it.slotTemp = it.name + item.nNum + "台";
                                // } else {
                                //     it.slotTemp = it.name;
                                // }
                            } else if (item.nNum == 1 && item.nNum > 0) {
                                it.slotTemp = it.name;
                            }
                        });
                    }
                    if (it.listType == 2) {
                        it.arrChecked.forEach((item) => {
                            if (item.openType) {
                                if (item.nNum > 0) {
                                    it.arrProduct.push({
                                        type: item.openName,
                                        item_id: item.id || "",
                                        item_name: item.goods_name || "",
                                        num: item.nNum,
                                    });
                                }
                                if (it.slotTemp == "") {
                                    it.slotTemp = it.slotTemp + item.openName;
                                } else {
                                    it.slotTemp =
                                        it.slotTemp + "+" + item.openName;
                                }
                            }
                        });
                    }
                    if (zStrSlot != "") {
                        if (it.slotTemp != "") {
                            zStrSlot = zStrSlot + "+" + it.slotTemp;
                        }
                    } else {
                        if (it.slotTemp != "") {
                            zStrSlot = it.slotTemp;
                        }
                    }
                });
                let arrShoppProduct = this.arrShoppOpen.filter((it) => {
                    return it.arrProduct.length > 0;
                });
                //  console.log(arrShoppProduct);
                let updateProduct = [];
                arrShoppProduct.forEach((item) => {
                    item.arrProduct.forEach((it) => {
                        updateProduct.push(it);
                    });
                });
                let posterData = {
                    zStrSlot: zStrSlot,
                    product: updateProduct,
                };
                 console.log(posterData.zStrSlot,'文字');return
                resolve(posterData);
            });
        },
        getBhow() {
            this.bShow = !this.bShow;
            if (!this.bShow) {
                this.nDecorationId = "";
                this.sDecoration = "";
                this.sDecorationName = "";
                this.agentName = "";
            }
        },
        getExperience() {
            this.bExperience = !this.bExperience;
        },
        // 判断是否选择家装公司
        getDecoration() {
            let that = this;
            if (that.sDecoration && that.nDecorationId !== 0) {
                return that.sDecoration;
            } else if (
                that.sDecoration &&
                that.nDecorationId === 0 &&
                that.sDecorationName
            ) {
                return that.sDecorationName;
            } else {
                return "设计师";
            }
        },
        // 提交之前验证所需是否填写
        getStrObjFun(){
            return new Promise((resolve) => {
                if (this.project == "") {
                    this.$toast("请填写合同编号!");
                    return false;
                }
                if (this.store == "") {
                    this.$toast("请填写门店/渠道!");
                    return false;
                }
                if (this.city == "") {
                    this.$toast("请填写城市!");
                    return false;
                }
                if (this.bExperience && this.arrLearn.length && this.lren == '') {
                    this.$toast("请选择体验间!");
                    return false;
                }
                if (this.sDecoration == "" && this.bShow) {
                    this.$toast("请选择家装公司!");
                    return false;
                }
                if (this.money == "") {
                    this.$toast("请填写成交金额!");
                    return false;
                }
                // 判断数据中是否有temp未选择的情况
                // let arrTemp = this.arrTemporary.filter(it=>{
                //     return it.type=='请选择产品分类'
                // })
                // console.log(arrTemp)
                // if(arrTemp.length){
                //     this.$toast("请选择TEMP的产品类别!");
                //     return
                // }
                resolve(true);
            })
        },
        submit(num) {
            var that = this;
            //需要时打开
            // if (that.imgLocalUrl == "" && num == 1) {
            //     this.$toast("请上传定金凭证~");
            //     return false;
            // }
            that.getStrObjFun().then((res) => {
                console.log(999999)
                that.$store.commit("loadSwitch", true);
                const myFont = new FontFace(
                    "myFont",
                    "url(/static/方正兰亭粗黑.TTF)"
                );
                const myFont2 = new FontFace(
                    "myFont2",
                    "url(/static/方正兰亭准黑.TTF)"
                );
                myFont2.load().then((font)=>{document.fonts.add(font);})
                // 加载文字字体
                myFont.load().then((font) => {
                        document.fonts.add(font);
                    }).then(() => {
                        Promise.all([that.getQrCodeBefore(num),that.getQrCodeAfter(num)]).then(res=>{
                            that.getFrom();
                        })
                    }).catch(err=>{
                                });
            });
        },
        // 获取扫码后的海报
        getQrCodeAfter(num){
            return new Promise((resolve,reject)=> {
                let that =this
                // let psterData = [];
                // 创建canvas
                let canvasCom = document.createElement("canvas");
                let context = canvasCom.getContext("2d");
                canvasCom.width = 750;
                canvasCom.height = 1547;
                context.fillStyle = "#fff";
                context.fillRect(
                    0,
                    0,
                    canvasCom.width,
                    canvasCom.height
                );
                // "产品型号：" +
                var type = "";
                // 处理文字
                let arrTemporaryTypeAll = JSON.parse(JSON.stringify(this.arrTemporary))
                let arrTemporaryType = arrTemporaryTypeAll.filter(it => {
                    return it.type != 'TEMP'
                })
                console.log(arrTemporaryTypeAll, '是是是')
                console.log(arrTemporaryType, '是是是2')
                // 将同一个type数据整合
                let arrReapet = []
                arrTemporaryType.forEach(item => {
                    let count = 0
                    arrTemporaryType.forEach(it => {
                        if (it.type == item.type) {
                            count++
                        }
                    })
                    if (count >= 2) {
                        arrReapet.push(item.type)
                    }
                })
                let arrReapetFilter = Array.from(new Set(arrReapet))
                let commonArr = []
                arrReapetFilter.forEach(item => {
                    let arr = []
                    arrTemporaryType.forEach((it, itx) => {
                        if (item == it.type) {
                            it.nCurrent = itx
                            arr.push(it)
                        }
                    })
                    commonArr.push(arr)
                })
                arrReapetFilter.forEach(item => {
                    arrTemporaryType.forEach((it, itx) => {
                        if (item == it.type) {
                            it.del = 1
                        }
                    })
                })
                let delArrTemporary = arrTemporaryType.filter(it => {
                    return it.del != 1
                })
                console.log(commonArr, '重复数据')
                let getArrTem = []
                commonArr.forEach(item => {
                    let obj = {
                        model_show: 0,
                        num_show: 0,
                        type: '',
                        num: 0,
                        item_name: '',
                        nCurrent: 0,
                    }
                    let sortArr = []
                    item.forEach(itA => {
                        sortArr.push(itA.nCurrent)
                        itA.items.forEach(it => {
                            obj.type = itA.type
                            if (itA.model_show == 1) {
                                obj.model_show = 1
                            }
                            if (itA.num_show == 1) {
                                obj.num_show = 1
                            }
                            obj.num += it.num
                            if (it.model != 'TEMP') {
                                obj.item_name = it.model
                            }
                        })
                    })
                    if (sortArr.length) {
                        obj.nCurrent = sortArr.sort((a, b) => a - b)[0];
                    }
                    getArrTem.push(obj)
                })
                getArrTem.forEach(it => {
                    delArrTemporary.splice(it.nCurrent, 0, it)
                })
                arrTemporaryType = delArrTemporary
                console.log(arrTemporaryType, '=合并数据')
                // 根据后台的顺序,排列合并后的数据
                console.log(this.arrSelectInfo, '排序数据')
                let arrTemporaryTypeFilter = []
                this.arrSelectInfo.forEach(item => {
                    arrTemporaryType.forEach(it => {
                        if (item == it.type) {
                            arrTemporaryTypeFilter.push(it)
                        }
                    })
                })
                console.log(arrTemporaryTypeFilter, '排序后的数据')
                arrTemporaryTypeFilter.forEach(it => {
                    if (type == '') {
                        if (it.model_show && it.num_show) {
                            if (it.num > 1) {
                                type = it.type + it.item_name + it.num + '台'
                            } else {
                                type = it.type + it.item_name
                            }
                        } else if (it.model_show && !it.num_show) {
                            type = it.type + it.item_name
                        } else if (!it.model_show && it.num_show) {
                            if (it.num > 1) {
                                type = it.type + it.num + '台'
                            } else {
                                type = it.type
                            }
                        } else if (!it.model_show && !it.num_show) {
                            type = it.type
                        }
                    } else {
                        if (it.model_show && it.num_show) {
                            if (it.num > 1) {
                                type += it.type + it.item_name + it.num + '台'
                            } else {
                                type += it.type + it.item_name
                            }
                        } else if (it.model_show && !it.num_show) {
                            type += it.type + it.item_name
                        } else if (!it.model_show && it.num_show) {
                            if (it.num > 1) {
                                type += it.type + it.num + '台'
                            } else {
                                type += it.type
                            }
                        } else if (!it.model_show && !it.num_show) {
                            type += it.type
                        }
                    }
                    type += '+'
                })
                type = type.slice(0, type.length - 1)
                console.log(type, '------>文字')
                var chr = type.split("");
                var temp = "";
                var row = [];
                // for (var a = 0; a < chr.length; a++) {
                //     if (a < 33) {
                //         if (temp.length > 31) {
                //             row.push(temp);
                //             temp = "";
                //         }
                //     } else {
                //         if (temp.length > 27) {
                //             row.push(temp);
                //             temp = "";
                //         }
                //     }
                //     temp += chr[a];
                // }
                var pattern2 = new RegExp("[A-Za-z]+");
                let lengthStr = 0
                for (var a = 0; a < chr.length; a++) {
                    if (lengthStr > 460) {
                        row.push(temp);
                        lengthStr = 0
                        temp = ''
                        if (pattern2.test(chr[a]) || parseFloat(chr[a]).toString() != "NaN" || chr[a] == '+' || chr[a] == '-') {
                            // 英文
                            lengthStr += 12
                            console.log('英')
                        } else {
                            // 中文
                            lengthStr += 24
                            console.log('中')
                        }
                        temp += chr[a];
                    } else {
                        if (pattern2.test(chr[a]) || parseFloat(chr[a]).toString() != "NaN" || chr[a] == '+' || chr[a] == '-') {
                            // 英文
                            lengthStr += 12
                            console.log('英')
                        } else {
                            // 中文
                            lengthStr += 24
                            console.log('中')
                        }
                        temp += chr[a];
                    }
                }
                row.push(temp);
                console.log(row)
                let isAva = false //判断是否五恒产品
                row.forEach(it => {
                    if (it.indexOf('AVA') > -1) {
                        console.log('五恒')
                        isAva = true
                    }
                })
                // 加载图片
                // 防止图片加载跨域
                var img = new Image();
                img.crossOrigin = "anonymous";
                if (row.length > 2) {
                    row[2] = row[2] + " ...";
                    if (isAva) {
                        img.src = require('@/assets/images/sales_poster_two_new_2.jpg');
                    } else {
                        img.src = require('@/assets/images/sales_poster_two_2.jpg');
                    }
                    row.splice(3);
                } else {
                    if (isAva) {
                        img.src = require('@/assets/images/sales_poster_new_2.jpg');
                    } else {
                        img.src = require('@/assets/images/sales_poster_2.jpg');
                    }
                    row.splice(2);
                }

                img.onload = function () {
                    context.drawImage(img, 0, 0);

                    addTxt(
                        false,
                        context,
                        that.city,
                        "#fedbc4",
                        "44px",
                        375,
                        210,
                        "center"
                    );
                    if (num == 0) {
                        addTxt(
                            true,
                            context,
                            "预览",
                            "#c6c6c6",
                            "200px",
                            canvasCom.width - 300,
                            620,
                            "center"
                        );
                    }
                    // + "门店/渠道"
                    if (that.bShow || that.bExperience) {
                        addTxt(
                            false,
                            context,
                            that.store,
                            "#fde9d1",
                            "30px",
                            375,
                            550,
                            "center"
                        );
                        addTxt(
                            false,
                            context,
                            `— ${that.bShow ? that.getDecoration() + '推荐' : ''}${(that.lren && that.bShow) ? ',' : ''}${that.lren ? that.lren + '体验' : ''}成交 —`,
                            "#fde9d1",
                            "30px",
                            375,
                            585,
                            "center"
                        );
                    } else {
                        addTxt(
                            false,
                            context,
                            that.store,
                            "#fde9d1",
                            "40px",
                            375,
                            570,
                            "center"
                        );
                    }
                    // addTxt(
                    //     context,
                    //     that.million + "万元",
                    //     "#fedbc4",
                    //     "140px",
                    //     375,
                    //     860,
                    //     "center"
                    // );
                    // 文字渐变，给文字添加阴影
                    var gradient = context.createLinearGradient(
                        0,
                        375,
                        0,
                        860
                    );
                    gradient.addColorStop(0.6, "#ffffff");
                    gradient.addColorStop(0.8, "#f5f5f5");
                    gradient.addColorStop(1, "#ebaf7b");
                    // 设置文字阴影的颜色为黑色，透明度为20%
                    context.shadowColor = "rgba(0, 0, 0, 0.5)";
                    // 将阴影向右移动15px，向上移动10px
                    context.shadowOffsetX = 7;
                    context.shadowOffsetY = 8;
                    // 轻微模糊阴影
                    // context.shadowBlur = 2;
                    context.font = "140px myFont";
                    context.fillStyle = gradient;

                    that.getNumber();

                    context.fillText(that.million + "万元", 375, 860);
                    // 设置文字阴影的颜色为黑色，透明度为20%
                    context.shadowColor = "rgba(0, 0, 0, 0)";
                    // 将阴影向右移动15px，向上移动10px
                    context.shadowOffsetX = 0;
                    context.shadowOffsetY = 0;
                    context.fillStyle = "#760716";
                    // ctx.strokeStyle = color; //设置笔触的颜色
                    // context.font =
                    //     'bold 24px "PingFang SC", "PingHei", "STHeitiSC-Light", "Myriad Set Pro", "Lucida Grande", "Helvetica Neue", "Helvetica", "microsoft yahei", "SimHei", "tahoma", "Arial", "Verdana", "sans-serif"';
                    context.font = "24px myFont";
                    context.textAlign = "left";
                    let topY = 910
                    if (row.length == 1) {
                        topY = 920
                    } else if (row.length == 2) {
                        topY = 906
                    } else {
                        topY = 892
                    }
                    for (var b = 0; b < row.length; b++) {

                        context.fillText(
                            row[b],
                            78,
                            topY + (b + 1) * 29
                        );
                    }
                    let data = [
                        {
                            name: "签单手：",
                            text: that.name1,
                            x: 50,
                            y: 1040,
                            textAlign: "left",
                        },
                        {
                            name: "方案设计师：",
                            text: that.name2,
                            x: 375,
                            y: 1040,
                            textAlign: "center",
                        },
                        {
                            name: "技术支持：",
                            text: that.name3,
                            x: 690,
                            y: 1040,
                            textAlign: "end",
                        },
                    ];
                    //两文本居中xy
                    let arrText = data.filter((it) => {
                        return it.text != "";
                    });
                    //辅助线
                    // context.strokeStyle = "#999";
                    // context.setLineDash([8]);
                    // context.moveTo(400, 1000);
                    // context.lineTo(400, 1100);
                    // context.stroke();
                    if (arrText.length) {
                        let text;
                        arrText.forEach((it) => {
                            if (text != undefined) {
                                text = text + it.name + it.text + "  ";
                            } else {
                                text = it.name + it.text + "  ";
                            }
                        });
                        addTxt(
                            false,
                            context,
                            text,
                            "#ffecdf",
                            "24px",
                            375,
                            1040,
                            "center"
                        );
                    }
                    // 生成图片 上传
                    let imgUrl = canvasCom.toDataURL("image/png");
                    oForm.getUploadimg({file: imgUrl}).then((upres) => {
                        let dateImgUrlAfter =upres.data.data.result.local_url;
                        let lookImgUrlAfter =upres.data.data.result.media_url;
                        that.dateImgUrlAfter = dateImgUrlAfter;
                        console.log(lookImgUrlAfter, '扫码后图片')
                        // that.arrPsterData = psterData.product;
                        // if (num == 0) {
                        //     that.lookImgUrl = lookImgUrl;
                        //     that.nLookImg = true;
                        // } else if (num == 1) {
                        //     that.getFrom();
                        // }
                        resolve(true)
                        // that.$store.commit("loadSwitch", false);
                    })
                }
            })
        },
        // 获取扫码前的海报
        getQrCodeBefore(num){
            return new Promise((resolve,reject)=> {
                let that =this
                // let psterData = [];
                // 创建canvas
                let canvasCom = document.createElement("canvas");
                let context = canvasCom.getContext("2d");
                canvasCom.width = 750;
                canvasCom.height = 1547;
                context.fillStyle = "#fff";
                context.fillRect(
                    0,
                    0,
                    canvasCom.width,
                    canvasCom.height
                );
                // "产品型号：" +
                var type = "";
                // 处理文字
                let arrTemporaryTypeAll = JSON.parse(JSON.stringify(this.arrTemporary))
                let arrTemporaryType = arrTemporaryTypeAll.filter(it => {
                    return it.type != 'TEMP'
                })
                // 将同一个type数据整合
                let arrReapet = []
                arrTemporaryType.forEach(item => {
                    let count = 0
                    arrTemporaryType.forEach(it => {
                        if (it.type == item.type) {
                            count++
                        }
                    })
                    if (count >= 2) {
                        arrReapet.push(item.type)
                    }
                })
                let arrReapetFilter = Array.from(new Set(arrReapet))
                let commonArr = []
                arrReapetFilter.forEach(item => {
                    let arr = []
                    arrTemporaryType.forEach((it, itx) => {
                        if (item == it.type) {
                            it.nCurrent = itx
                            arr.push(it)
                        }
                    })
                    commonArr.push(arr)
                })
                arrReapetFilter.forEach(item => {
                    arrTemporaryType.forEach((it, itx) => {
                        if (item == it.type) {
                            it.del = 1
                        }
                    })
                })
                let delArrTemporary = arrTemporaryType.filter(it => {
                    return it.del != 1
                })
                console.log(commonArr, '重复数据')
                let getArrTem = []
                commonArr.forEach(item => {
                    let obj = {
                        model_show: 0,
                        num_show: 0,
                        type: '',
                        num: 0,
                        item_name: '',
                        nCurrent: 0,
                    }
                    let sortArr = []
                    item.forEach(itA => {
                        sortArr.push(itA.nCurrent)
                        itA.items.forEach(it => {
                            obj.type = itA.type
                            if (itA.model_show == 1) {
                                obj.model_show = 1
                            }
                            if (itA.num_show == 1) {
                                obj.num_show = 1
                            }
                            obj.num += it.num
                            if (it.model != 'TEMP') {
                                obj.item_name = it.model
                            }
                        })
                    })
                    if (sortArr.length) {
                        obj.nCurrent = sortArr.sort((a, b) => a - b)[0];
                    }
                    getArrTem.push(obj)
                })
                getArrTem.forEach(it => {
                    delArrTemporary.splice(it.nCurrent, 0, it)
                })
                arrTemporaryType = delArrTemporary
                console.log(arrTemporaryType, '=合并数据')
                // 根据后台的顺序,排列合并后的数据
                console.log(this.arrSelectInfo, '排序数据')
                let arrTemporaryTypeFilter = []
                this.arrSelectInfo.forEach(item => {
                    arrTemporaryType.forEach(it => {
                        if (item == it.type) {
                            arrTemporaryTypeFilter.push(it)
                        }
                    })
                })
                console.log(arrTemporaryTypeFilter, '排序后的数据')
                arrTemporaryTypeFilter.forEach(it => {
                    if (type == '') {
                        if (it.model_show && it.num_show) {
                            if (it.num > 1) {
                                type = it.type + it.item_name + it.num + '台'
                            } else {
                                type = it.type + it.item_name
                            }
                        } else if (it.model_show && !it.num_show) {
                            type = it.type + it.item_name
                        } else if (!it.model_show && it.num_show) {
                            if (it.num > 1) {
                                type = it.type + it.num + '台'
                            } else {
                                type = it.type
                            }
                        } else if (!it.model_show && !it.num_show) {
                            type = it.type
                        }
                    } else {
                        if (it.model_show && it.num_show) {
                            if (it.num > 1) {
                                type += it.type + it.item_name + it.num + '台'
                            } else {
                                type += it.type + it.item_name
                            }
                        } else if (it.model_show && !it.num_show) {
                            type += it.type + it.item_name
                        } else if (!it.model_show && it.num_show) {
                            if (it.num > 1) {
                                type += it.type + it.num + '台'
                            } else {
                                type += it.type
                            }
                        } else if (!it.model_show && !it.num_show) {
                            type += it.type
                        }
                    }
                    type += '+'
                })
                type = type.slice(0, type.length - 1)
                console.log(type, '------>文字')
                var chr = type.split("");
                var temp = "";
                var row = [];
                // for (var a = 0; a < chr.length; a++) {
                //     if (a < 33) {
                //         if (temp.length > 31) {
                //             row.push(temp);
                //             temp = "";
                //         }
                //     } else {
                //         if (temp.length > 27) {
                //             row.push(temp);
                //             temp = "";
                //         }
                //     }
                //     temp += chr[a];
                // }
                var pattern2 = new RegExp("[A-Za-z]+");
                let lengthStr = 0
                for (var a = 0; a < chr.length; a++) {
                    if (lengthStr > 460) {
                        row.push(temp);
                        lengthStr = 0
                        temp = ''
                        if (pattern2.test(chr[a]) || parseFloat(chr[a]).toString() != "NaN" || chr[a] == '+' || chr[a] == '-') {
                            // 英文
                            lengthStr += 12
                            console.log('英')
                        } else {
                            // 中文
                            lengthStr += 24
                            console.log('中')
                        }
                        temp += chr[a];
                    } else {
                        if (pattern2.test(chr[a]) || parseFloat(chr[a]).toString() != "NaN" || chr[a] == '+' || chr[a] == '-') {
                            // 英文
                            lengthStr += 12
                            console.log('英')
                        } else {
                            // 中文
                            lengthStr += 24
                            console.log('中')
                        }
                        temp += chr[a];
                    }
                }
                row.push(temp);
                console.log(row)
                let isAva = false //判断是否五恒产品
                row.forEach(it => {
                    if (it.indexOf('AVA') > -1) {
                        console.log('五恒')
                        isAva = true
                    }
                })
                // 加载图片
                // 防止图片加载跨域
                var img = new Image();
                img.crossOrigin = "anonymous";
                if (row.length > 2) {
                    row[2] = row[2] + " ...";
                    if (isAva) {
                        img.src = require('@/assets/images/poster/sales_poster_two_new_2.jpg');
                    } else {
                        img.src = require('@/assets/images/poster/sales_poster_two_2.jpg');
                    }
                    row.splice(3);
                } else {
                    if (isAva) {
                        img.src = require('@/assets/images/poster/sales_poster_new_2.jpg');
                    } else {
                        img.src = require('@/assets/images/poster/sales_poster_2.jpg');
                    }
                    row.splice(2);
                }
                let imgQr = new Image();
                imgQr.crossOrigin = "anonymous";
                console.log(that.qrCodeBase64,'二维码地址')
                // imgQr.src='https://pro-mixed-tt.babycdn.com/aotest/uploads/act/16879313816483.jpg'
                imgQr.src=that.qrCodeBase64

                img.onload = function () {
                    context.drawImage(img, 0, 0);
                    imgQr.onload=function (){
                        context.lineJoin = "round";
                        context.strokeRect(597, 1267, 130, 130);
                        context.fillRect(597, 1267, 130, 130)
                        context.drawImage(imgQr, 600, 1270, 124, 124);
                        addTxt(
                            false,
                            context,
                            that.city,
                            "#fedbc4",
                            "44px",
                            375,
                            210,
                            "center"
                        );
                        if (num == 0) {
                            addTxt(
                                true,
                                context,
                                "预览",
                                "#c6c6c6",
                                "200px",
                                canvasCom.width - 300,
                                620,
                                "center"
                            );
                        }
                        // + "门店/渠道"
                        addTxt(
                            false,
                            context,
                            that.store,
                            "#fde9d1",
                            "40px",
                            375,
                            570,
                            "center"
                        );
                        // addTxt(
                        //     context,
                        //     that.million + "万元",
                        //     "#fedbc4",
                        //     "140px",
                        //     375,
                        //     860,
                        //     "center"
                        // );
                        // 文字渐变，给文字添加阴影
                        var gradient = context.createLinearGradient(
                            0,
                            375+70,
                            0,
                            860+70
                        );
                        gradient.addColorStop(0.6, "#ffffff");
                        gradient.addColorStop(0.8, "#f5f5f5");
                        gradient.addColorStop(1, "#ebaf7b");
                        // 设置文字阴影的颜色为黑色，透明度为20%
                        context.shadowColor = "rgba(0, 0, 0, 0.5)";
                        // 将阴影向右移动15px，向上移动10px
                        context.shadowOffsetX = 7;
                        context.shadowOffsetY = 8;
                        // 轻微模糊阴影
                        // context.shadowBlur = 2;
                        context.font = "140px myFont";
                        context.fillStyle = gradient;

                        that.getNumber();

                        context.fillText(that.million + "万元", 375, 930);
                        // 设置文字阴影的颜色为黑色，透明度为20%
                        context.shadowColor = "rgba(0, 0, 0, 0)";
                        // 将阴影向右移动15px，向上移动10px
                        context.shadowOffsetX = 0;
                        context.shadowOffsetY = 0;
                        context.fillStyle = "#760716";
                        // ctx.strokeStyle = color; //设置笔触的颜色
                        // context.font =
                        //     'bold 24px "PingFang SC", "PingHei", "STHeitiSC-Light", "Myriad Set Pro", "Lucida Grande", "Helvetica Neue", "Helvetica", "microsoft yahei", "SimHei", "tahoma", "Arial", "Verdana", "sans-serif"';
                        context.font = "24px myFont";
                        context.textAlign = "left";
                        // let topY = 910
                        // if (row.length == 1) {
                        //     topY = 920
                        // } else if (row.length == 2) {
                        //     topY = 906
                        // } else {
                        //     topY = 892
                        // }
                        // for (var b = 0; b < row.length; b++) {
                        //
                        //     context.fillText(
                        //         row[b],
                        //         78,
                        //         topY + (b + 1) * 29
                        //     );
                        // }
                        let data = [
                            {
                                name: "签单手：",
                                text: that.name1,
                                x: 50,
                                y: 1040,
                                textAlign: "left",
                            },
                            {
                                name: "方案设计师：",
                                text: that.name2,
                                x: 375,
                                y: 1040,
                                textAlign: "center",
                            },
                            {
                                name: "技术支持：",
                                text: that.name3,
                                x: 690,
                                y: 1040,
                                textAlign: "end",
                            },
                        ];
                        //两文本居中xy
                        let arrText = data.filter((it) => {
                            return it.text != "";
                        });
                        //辅助线
                        // context.strokeStyle = "#999";
                        // context.setLineDash([8]);
                        // context.moveTo(400, 1000);
                        // context.lineTo(400, 1100);
                        // context.stroke();
                        if (arrText.length) {
                            let text;
                            arrText.forEach((it) => {
                                if (text != undefined) {
                                    text = text + it.name + it.text + "  ";
                                } else {
                                    text = it.name + it.text + "  ";
                                }
                            });
                            addTxt(
                                false,
                                context,
                                text,
                                "#ffecdf",
                                "24px",
                                375,
                                1040,
                                "center"
                            );
                        }
                        // 生成图片 上传
                        let imgUrl = canvasCom.toDataURL("image/png");
                        oForm.getUploadimg({file: imgUrl}).then((upres) => {
                            let dateImgUrl =
                                upres.data.data.result.local_url;
                            let lookImgUrl =
                                upres.data.data.result.media_url;
                            // localStorage.setItem(
                            //     "dateImgUrl",
                            //     lookImgUrl
                            // );
                            oStorage.setStorage(
                                "dateImgUrl",
                                lookImgUrl
                            );
                            that.dateImgUrl = dateImgUrl;
                            console.log(lookImgUrl, '扫码前图片')
                            // that.arrPsterData = psterData.product;
                            // if (num == 0) {
                            //     that.lookImgUrl = lookImgUrl;
                            //     that.nLookImg = true;
                            // } else if (num == 1) {
                            //     that.getFrom();
                            // }
                            resolve(true)
                            // that.$store.commit("loadSwitch", false);
                        })
                    }

                }
            })
        },
        getFrom() {
            let that = this;
            let data = {
                code: that.project,
                city: that.city,
                store: that.store,
                amount: that.money,
                usign: that.name1,
                udesign: that.name2,
                utech: that.name3,
                img: that.dateImgUrl,//扫码前图片
                img_detail:that.dateImgUrlAfter,//扫码后图片
                img_check: that.imgLocalUrl,
                company_name: that.sDecoration,
                company_mark: that.sDecorationName,
                agent_name: that.agentName,
                is_design: that.bShow ? 1 : 0,
                room_name: that.lren,
            };
            // 处理product
            let arrProduct = JSON.parse(JSON.stringify(that.arrTemporary))
            let arrProductAfter=[]
            arrProduct.forEach(item=>{
                item.items.forEach(it=>{
                    let obj = {}
                    obj.item_id=0
                    obj.type=item.type
                    obj.item_name=it.model
                    obj.num=it.num
                    arrProductAfter.push(obj)
                })
            })
            data.product=JSON.stringify(arrProductAfter)
            oForm.getPosteradd(data).then((res) => {
                this.$store.commit("loadSwitch", false);
                this.$router.push({ path: "/other/poster/lookimg" });
            });
        },
    },
};
</script>


<style lang="scss" scoped>
.qrcode {
    width: 200px;
    margin:0 auto 0;
    height: 200px;
    background-color: #fff;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: -1;
    top: -100vh;
}
.mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 888;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: opitonIt 0.5s forwards;
}
.popup-close {
    position: absolute;
    top: -15px;
    right: -15px;
    background: url("~@/assets/images/antV2/basicinfo/close.png") top/100% auto
        no-repeat;
    width: 42px;
    height: 42px;
    flex-shrink: 0;
}
.label {
    font-size: 30px;
    color: rgb(45, 45, 45);
    font-weight: bold;
    margin-right: 30px;
    flex-shrink: 0;
}
.del {
    width: 45px;
    height: 45px;
    background: url(~@/assets/images/del_icon.png) no-repeat center/100% 100%;
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 4;
}
.one {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .myLike {
        margin-right: 20px;
        font-size: 30px;
        font-weight: 700;
        text-decoration: underline;
        color: #2c7aec;
        letter-spacing: 2px;
    }
}
.public-popup {
    width: 652px;
    min-height: 500px;
    border-radius: 20px;
    background-color: rgb(255, 255, 255);
    padding: 40px 20px;
    z-index: 995;
    position: relative;

    .popup-tips {
        font-size: 28px;
        color: #999999;
    }

    .popup-title {
        font-size: 34px;
        color: rgb(45, 45, 45);
    }
    .del-group {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        margin-top: 20px;
        height: 300px;
        overflow: auto;
        .del-tag-item {
            min-width: 180px;
            padding: 0 30px;
            flex-shrink: 0;
            margin: 0 8px 20px 8px;
            background-color: rgb(247, 247, 253);
            border-radius: 55px;
            font-size: 30px;
            color: rgb(45, 45, 45);
            text-align: center;
            height: 70px;
            line-height: 72px;
            margin-right: 15px;
        }
        .active {
            border-width: 2px;
            border-color: rgb(44, 122, 236);
            border-style: solid;
            color: rgb(44, 122, 236);
        }
    }
    .group {
        flex-wrap: wrap;

        .tag {
            margin-top: 15px;
            flex-wrap: wrap;

            .tag-item {
                min-width: 180px;
                padding: 0 30px;
                flex-shrink: 0;
                margin: 0 8px 20px 8px;
            }

            .other {
                min-width: 130px;
                padding: 0 20px;
            }

            .active {
                border-width: 2px;
                border-color: rgb(44, 122, 236);
                border-style: solid;
                color: rgb(44, 122, 236);
            }
        }
    }

    .btn {
        margin-top: 50px;
        display: flex;
        justify-content: center;

        button {
            width: 290px;
            height: 80px;
            background-color: #2c7aec;
            border-radius: 55px;
            outline: none;
            color: #fff;
            font-size: 30px;
        }
    }

    .scorll {
        height: 800px;
        overflow-x: scroll;
    }
}
.opens-bottom {
    font-size: 25px;
    text-align: center;
}
.submit {
    width: 80%;
    margin: 30px auto;
    background: #2c7aec;
    line-height: 100px;
    text-align: center;
    color: #fff;
    font-size: 40px;
    border-radius: 50px;
    letter-spacing: 6px;
    padding-left: 12px;
}
.lookbtn {
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 30px;
    justify-content: center;
    .lookBaek {
        width: 40%;
        // margin: 30px auto;
        background: #2c7aec;
        line-height: 80px;
        text-align: center;
        color: #fff;
        font-size: 40px;
        border-radius: 40px;
        letter-spacing: 6px;
        padding-left: 12px;
        margin-left: 20px;
        &:first-child {
            margin-left: 0;
        }
    }
}
.sales-box {
    width: 100%;
    min-height: 100vh;
    padding: 20px 30px;
    box-sizing: border-box;
    .title {
        width: 60%;
        font-size: 38px;
        font-weight: 700;
        display: flex;
        align-items: center;
        &::before {
            content: "";
            display: inline-block;
            width: 8px;
            height: 38px;
            background: #2c7aec;
            margin-right: 10px;
        }
    }
    .required {
        &::before {
            content: "*";
            position: absolute;
            color: red;
            left: 10px;
        }
    }

    .xinhao {
        .left_border {
            .twoListType_item {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                .openListType {
                    height: 32px;
                    width: 32px;
                    // border-radius: 50%;
                    border: 1px solid rgb(107, 107, 107);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 50px;
                    box-sizing: border-box;
                    &::before {
                        content: "";
                        display: inline-block;
                        height: 24px;
                        width: 24px;
                        // border-radius: 50%;
                        background: #2c7aec;
                    }
                }
                .openNoListType {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 32px;
                    width: 32px;
                    // border-radius: 50%;
                    border: 1px solid rgb(107, 107, 107);
                    margin-right: 30px;
                    box-sizing: border-box;
                }
            }
        }
        .twoListType {
            width: 100%;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // justify-content: center;
            .twoListType_item {
                width: 33%;
                display: flex;
                align-items: center;
                // justify-content: center;
                font-size: 30px;
                .openListType {
                    height: 32px;
                    width: 32px;
                    // border-radius: 50%;
                    border: 1px solid rgb(107, 107, 107);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                    box-sizing: border-box;
                    &::before {
                        content: "";
                        display: inline-block;
                        height: 24px;
                        width: 24px;
                        // border-radius: 50%;
                        background: #2c7aec;
                    }
                }
                .openNoListType {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 32px;
                    width: 32px;
                    // border-radius: 50%;
                    border: 1px solid rgb(107, 107, 107);
                    margin-right: 30px;
                    box-sizing: border-box;
                }
            }
        }
        .sales-name {
            width: 39% !important;
        }
        .shopp_warp {
            width: 61% !important;
            .shopp_list {
                height: 80px;
                // padding: 20px 0;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #e0e0e0;
                &:last-child {
                    border-bottom: 0;
                }
            }
        }
    }
    .sales-item {
        position: relative;
        width: 100%;
        // line-height: 80px;
        // height: 80px;
        border-radius: 10px;
        border: 2px solid #78b0ff;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px;
        box-sizing: border-box;
        margin-bottom: 20px;
        &:first-child {
            margin-top: 20px;
        }
        .sales-name {
            width: 45%;
            height: 80px;
            line-height: 80px;
            font-size: 30px;
            div {
                text-align-last: justify;
                text-align: justify;
                width: 80%;
                display: inline-block;
            }
        }
        .addOrDel {
            display: flex;
            align-items: center;
            .orInat {
                width: 45px;
                height: 45px;
                background: url("~@/assets/images/add_num.png") no-repeat
                    center/100% 100%;
            }
            .num {
                width: 70px;
                height: 45px;
                font-size: 26px;
                //margin: 0 40px;
                border: 1px solid #78b0ff;

                .numInput {
                    // height: auto !important;
                    height: 40px;
                    width: 100%;
                    text-align: center;
                }
            }
            .numa {
                width: 50px;
                height: 45px;
                line-height: 45px;
                font-size: 26px;
                //margin: 0 40px;
                border-bottom: 1px solid #78b0ff;
                input {
                    width: 100%;
                }
            }
            .orInatdel {
                width: 45px;
                height: 45px;
                background: url("~@/assets/images/del_num.png") no-repeat
                    center/100% 100%;
            }
        }
        input {
            width: 55%;
            // height: 80px;
            font-size: 28px;
            background: #fff;
        }
        .is_design {
            width: 55%;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .choose {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50%;
                font-size: 28px;
                .choose_dian {
                    height: 32px;
                    width: 32px;
                    border-radius: 50%;
                    border: 1px solid rgb(107, 107, 107);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                    box-sizing: border-box;
                    &::before {
                        content: "";
                        display: inline-block;
                        height: 20px;
                        width: 20px;
                        border-radius: 50%;
                        background: #2c7aec;
                    }
                }
                .choose_no_dian {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 32px;
                    width: 32px;
                    border-radius: 50%;
                    border: 1px solid rgb(107, 107, 107);
                    margin-right: 10px;
                    box-sizing: border-box;
                }
            }
        }
        .name-required{
            display: flex;
            font-size: 32px;
            width: 45%;
            div{
                width: 80%;
                font-weight: 500;
                text-align: justify;
                text-align-last: justify;
            }
            span{
                padding-left:5px;
            }
        }
        .none-required{
            &:before{
                display: none;
            }
            div{
                color:#2c7aec;
            }
        }
        .shopp_warp-two{
            .shopp_name{
                width: 80%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
}
.addImg {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.812);
    z-index: 10;
    overflow: auto;
    animation: opitonIt 1s forwards;
    .addImgWarp {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        height: 900px;
        width: 90%;
        background: #fff;
        .addTitle {
            text-align: center;
            padding: 20px 0;
            box-sizing: border-box;
            font-size: 40px;
            color: #2c7aec;
            font-weight: 700;
        }
        .addImgUrl {
            margin: 0 auto;
            width: 75%;
            height: 650px;
            border: 1px solid rgb(107, 107, 107);
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            img {
                width: 100%;
            }
            input {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                z-index: 2;
            }
            .tip {
                h3 {
                    color: #333333;
                    font-size: 34px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &::before {
                        content: "";
                        width: 45px;
                        height: 45px;
                        margin-right: 20px;
                        background: url(~@/assets/images/antV2/icon_sc.png)
                            no-repeat center/100% 100%;
                    }
                }

                p {
                    color: #333333;
                    font-size: 28px;
                    line-height: 50px;
                    margin-top: 50px;
                    text-align: center;
                }
            }
        }
        .addBtn {
            width: 80%;
            margin: 30px auto;
            background: #2c7aec;
            line-height: 100px;
            text-align: center;
            color: #fff;
            font-size: 40px;
            border-radius: 50px;
            letter-spacing: 6px;
            padding-left: 12px;
        }
    }
}
.lookImgBk {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.812);
    z-index: 11;
    overflow: auto;
    animation: opitonIt 1s forwards;
    display: flex;
    align-items: center;
    justify-content: center;
    .img_url {
        // margin: 30px auto;
        width: 90%;
        img {
            width: 100%;
        }
    }
}
.lookImg {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.812);
    z-index: 9;
    overflow: auto;
    animation: opitonIt 1s forwards;
    .img_url {
        margin: 30px auto;
        width: 90%;
        img {
            width: 100%;
        }
    }
}
.seack {
    width: 18%;
    height: 50px;
    background: #2c7aec;
    border-radius: 20px;
    color: #fff;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}
@keyframes opitonIt {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
